// extracted by mini-css-extract-plugin
module.exports = {"card":"CardCompanyContentBoost_card__jfa1Y","cardFooter":"CardCompanyContentBoost_cardFooter__05NVi"};